import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SuperFooterService, ESupportType } from '../services/super-footer.service';
import { environment } from '../../../environments/environment';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject, FacilitySummaryObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { AmplitudeAnalyticsService } from '../services/amplitude-analytics.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit, OnDestroy, AfterViewInit {
  rootScopeData: RootScopeDeclare;
  currentYear: number;
  fragment: any;
  currentPath:string;
  footerContentLoaded: boolean = false;
  currentHostPath: string;

  // subscriptions
  private _facilityOnChange: Subscription;
  currentFacility: FacilityObject;

  constructor(
    private rootScopeService: RootScopeService,
    private route: ActivatedRoute,
    private superFooterService: SuperFooterService,
    private router: Router,
    private _facilityService: FacilityService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url) {
          this.route.fragment.subscribe(fragment => (this.fragment = fragment));
        }
      }
    });
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    this.getRootScopeData();
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
    this.setFooterHeight();
    this.currentYear = new Date().getFullYear();
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    this.currentPath = this.router.url.split('?')[0];
    this.currentHostPath = environment.currentHostPath;
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.footerContentLoaded = true;
  }

  @HostListener('window:resize', ['$event'])
  setFooterHeight(): void {
    const ele = <HTMLElement>document.getElementById('halo-footer-cntr');
    this.rootScopeData.footerHeight = ele.offsetHeight;
    this.rootScopeData.contentHeight = this.rootScopeData.contentAreaHeight - this.rootScopeData.footerHeight;
  }

  openInNewTab(screenName: string) {
    if (screenName == 'Parts') {
      this._amplitudeAnalytics.logEvent({elementName: 'Order Parts', action: 'Click'}, 'Order Parts');
      if (localStorage.getItem('ssoFederated') != null && localStorage.getItem('ssoFederated') == 'true') {
        window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCAcpSSOLogin.jsp', '_blank');
      } else {
        window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCZzpHome.jsp', '_blank');
      }
    }
  }

  gotoTop() {
    const elmnt = <HTMLElement>document.getElementById('page-cntr');
    elmnt.scrollTop = 0;
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        const ele = <HTMLElement>document.querySelector('#' + this.fragment);
        ele.scrollIntoView();
      }
    } catch (e) {}
  }

  onRequestTechnician() {
    this.superFooterService.switchForm(ESupportType.TECHNICIAN_VISIT);
  }

  tryToMoveAwayFromCurrentPage(path: string): boolean {
    this.rootScopeData.pathToNavigate = path;
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      return false;
    } else {
      if (this.rootScopeData.pathToNavigate.indexOf('app.html') >= 0) {
        window.location.href = this.rootScopeData.pathToNavigate;
      } else if (this.rootScopeData.pathToNavigate !== this.router.url) {
        window.location.href ='halo.html#'+ this.rootScopeData.pathToNavigate;
      }
      return true;
    }
  }

  onVisitPage(brand: string) {
    this._amplitudeAnalytics.logEvent({elementName: 'Site', action: 'Click', additionalProperty: {brand: brand}}, 'Brand Site Visit');
  }
  
}
